/** Mirrors extension auto-suspend.types (per-session idle tab suspend). */

export interface AutoSuspendConfig {
  enabled: boolean;
  idleMinutes: number;
  excludeDomains?: string[];
}

export const DEFAULT_AUTO_SUSPEND_CONFIG: AutoSuspendConfig = {
  enabled: false,
  idleMinutes: 15,
  excludeDomains: [],
};

export const AUTO_SUSPEND_QUICK_EXCLUDE_HOSTS = [
  'meet.google.com',
  'zoom.us',
  'mail.google.com',
  'calendar.google.com',
] as const;
